module.exports = __webpack_public_path__ + "img/0004.57af50de.png";